import React, { useState } from 'react';

const QASection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "Quels sont les prérequis pour suivre les formations ?",
      answer: "Aucun prérequis spécifique n'est nécessaire pour nos formations de base. Nous accueillons les débutants complets et adaptons le rythme selon votre niveau. Pour les formations avancées, une connaissance de base du logiciel est recommandée."
    },
    {
      id: 2,
      question: "Les formations sont-elles certifiantes ?",
      answer: "Oui, toutes nos formations délivrent un certificat de réussite . Ce certificat atteste de vos compétences acquises et peut être ajouté à votre CV ou profil LinkedIn."
    },
    {
      id: 3,
      question: "Puis-je suivre les cours à distance ?",
      answer: "Absolument ! Nous proposons des formations en ligne interactives avec support en temps réel. Vous pouvez également choisir des sessions hybrides combinant présentiel et distanciel selon vos préférences."
    },
    {
      id: 4,
      question: "Quelle est la durée moyenne d'une formation ?",
      answer: "La durée varie: De 10h pour les formations courtes À 15h-20h pour les formations complètes. Nous proposons des rythmes flexibles adaptés à votre emploi du temps."
    },
  ];

  const categories = ["All", "General", "Pricing", "Billing", "Support", "Security", "Integration"];

  const [selectedCategory, setSelectedCategory] = useState("All");

  const filteredFaqs = selectedCategory === "All" 
    ? faqs 
    : faqs.filter(faq => faq.category === selectedCategory);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div id="faq" className="py-12 bg-gray-50  px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 tracking-tight">
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Find answers to common questions about our service
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4 ">
          {filteredFaqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl border border-gray-200 overflow-hidden transition-all duration-500 ${
                activeIndex === index
                  ? 'shadow-xl shadow-blue-500/10 border-blue-200'
                  : 'shadow-sm hover:shadow-md'
              }`}
            >
              {/* Question */}
              <button
                className="w-full px-6 py-5 text-left focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className={`w-2 h-2 rounded-full transition-all duration-300 ${
                      activeIndex === index ? 'bg-blue-500 scale-125' : 'bg-gray-300'
                    }`} />
                    <h3 className="text-lg font-semibold text-gray-900 pr-4">
                      {faq.question}
                    </h3>
                  </div>
                  <div className="flex-shrink-0 ml-4">
                    <svg
                      className={`w-5 h-5 text-blue-500 transform transition-transform duration-500 ${
                        activeIndex === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
                
           
              </button>

              {/* Answer with Animation */}
              <div
                className={`px-6 overflow-hidden transition-all duration-500 ease-in-out ${
                  activeIndex === index
                    ? 'max-h-96 pb-5 opacity-100'
                    : 'max-h-0 opacity-0'
                }`}
              >
                <div className="pt-2 pb-2">
                  <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent mb-5" />
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QASection;